module.exports = __webpack_public_path__ + "static/pay-d193ffc790b08741a23045fbb59d6e32.png";